var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-space-around align-space-around flex-wrap align-self-auto"},_vm._l((_vm.books),function(book){return _c('CardBook',{key:book.id,staticClass:"ma-10",attrs:{"inBib":_vm.inBib,"inSouhait":_vm.inSouhait,"id":book.id || book.volumeInfo.id,"title":book.volumeInfo.title,"author":book.volumeInfo.authors
        ? book.volumeInfo.authors[0]
          ? book.volumeInfo.authors[0]
          : 'Inconnu'
        : 'Inconnu',"description":book.volumeInfo.description
        ? book.volumeInfo.description.length > 100
          ? book.volumeInfo.description.slice(0, 100)
          : book.volumeInfo.description
        : 'Pas de description pour ce livre.',"image":book.volumeInfo.imageLinks ? book.volumeInfo.imageLinks.thumbnail : null,"categories":book.volumeInfo.categories ? book.volumeInfo.categories : null}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }